import heroImg from "./images/hero-image.png";
import heroPizzaImg from "./images/hero-image-pizza.png";
import heroFaceImg from "./images/hero-face-image.png";
import heroIcon1 from "./images/hero-icon-image.png";
import heroIcon2 from "./images/hero-icon-image-2.svg";
import heroIcon3 from "./images/hero-icon-image-3.svg";
import heroReview1 from "./images/hero-review-1.png";
import heroReview2 from "./images/hero-review-2.png";
import heroReview3 from "./images/hero-review-3.png";
import foodImg1 from "./images/food-image-1.png";
import foodImg2 from "./images/food-image-2.png";
import foodImg3 from "./images/food-image-3.png";
import foodImg4 from "./images/food-image-4.png";
import foodImg5 from "./images/food-image-5.png";
import foodImg6 from "./images/food-image-6.png";
import foodImg7 from "./images/food-image-7.jpg";
import foodImg8 from "./images/food-image-8.jpg";
import foodImg9 from "./images/food-image-9.jpg";
import foodImg10 from "./images/food-image-10.jpg";
import menuImg1 from "./images/menu-food-1.png";
import menuImg2 from "./images/menu-food-2.png";
import menuImg3 from "./images/menu-food-3.png";
import menuImg4 from "./images/menu-food-4.png";
import menuImg5 from "./images/menu-food-5.png";
import menuImg6 from "./images/menu-food-6.png";
import menuIcon1 from "./images/menu-icon-1.svg";
import menuIcon2 from "./images/menu-icon-2.svg";
import menuIcon3 from "./images/menu-icon-3.svg";
import menuIcon4 from "./images/menu-icon-4.svg";
import menuIcon5 from "./images/menu-icon-5.svg";
import serviceImg1 from "./images/service-image-1.svg";
import serviceImg2 from "./images/service-image-2.svg";
import serviceImg3 from "./images/service-image-3.svg";
import customerImg1 from "./images/customer-image-1.png";
import customerImg2 from "./images/customer-image-2.png";
import customerImg3 from "./images/customer-image-3.png";
import customerImg4 from "./images/customer-image-4.png";
import noCartItemsImg from "./images/no-cart-items-image.svg";
import profileImg from "./images/profile-image.png";
import appImg from "./images/app-image.png";
import logoImg from "./images/logo-image.svg";
import aboutImg from "./images/about-image.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    heroImg,
    heroPizzaImg,
    heroFaceImg,
    heroIcon1,
    heroIcon2,
    heroIcon3,
    heroReview1,
    heroReview2,
    heroReview3,
    foodImg1,
    foodImg2,
    foodImg3,
    foodImg4,
    foodImg5,
    foodImg6,
    foodImg7,
    foodImg8,
    foodImg9,
    foodImg10,
    menuImg1,
    menuImg2,
    menuImg3,
    menuImg4,
    menuImg5,
    menuImg6,
    menuIcon1,
    menuIcon2,
    menuIcon3,
    menuIcon4,
    menuIcon5,
    serviceImg1,
    serviceImg2,
    serviceImg3,
    customerImg1,
    customerImg2,
    customerImg3,
    customerImg4,
    noCartItemsImg,
    profileImg,
    appImg,
    logoImg,
    aboutImg,
}